import React from 'react'

export default ({ highestScore, score, width, unit }) => (
    <text x={width / 2 - unit * 9} y={unit * 3.5} fontSize={unit} className='score'>
        HIGHEST: {highestScore} &nbsp; &nbsp; SCORE: {score}</text>
)
